/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-09 23:38:44
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {OperationLogDOI} from "./api/operationLogApi";
import OperationLogService from "./service/operationLogService";
import './operationLog.less';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import { createNamespace, createBEM } from 'src/util/bem';
import QueryForm from 'src/components/queryForm/queryForm';
import Button from 'src/types/iview/Button';
let bem = createBEM('operation-log')

@Component({name: 'operation-log'})
export default class OperationLog extends BasicSearchPage<OperationLogService, OperationLogDOI.RowDataI, OperationLogDOI.QueryRowDataParamsI> {
    className: string = bem()
    mn: string = ''

    @override
    renderHead(h) {
        return <div></div>
    }
	@override
	loadService () {
		this.service = new OperationLogService(this)
    }

    stationChange(data: StationListDOI.RowDataI) {
        let item = this.queryFormData.find(i=> i.field === 'component')
        item!.props.searchParams = {mn: data.mn}
        this.searchTable()
    }
    
    mounted() {
        this.mn = this.$route.query.mn;
        Bus.$on(Events.StationChange, this.stationChange);
        this.service.initSearchParams()
		this.searchTable()
    }
    
    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
        this.timeout = null
    }
}